import { computed, ref, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { addPayChnl, editPayChnl } from '@/api/payManage/domian';
import { message } from 'ant-design-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AddOrEditModal',
  props: {
    modalVisible: {
      type: Boolean
    },
    editItem: null
  },
  emits: ['update:modalVisible', 'refresh', 'clearEditItem'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const isEdit = computed(() => {
      var _props$editItem;
      return !!((_props$editItem = props.editItem) !== null && _props$editItem !== void 0 && _props$editItem.id);
    });
    const visible = ref(false),
      accountForm = ref(),
      formValue = ref({
        dictDesc: undefined,
        dictDetailCode: undefined,
        payFor: undefined,
        callbackSuffix: undefined
      }),
      typeList = ref([{
        label: 'APP',
        value: 1
      }, {
        label: '小游戏',
        value: 2
      }, {
        label: 'PC',
        value: 3
      }]);
    const changeform = async (queryObj = {}) => {
      var _props$editItem2;
      const {
        dictDesc,
        dictDetailCode,
        payFor,
        callbackSuffix
      } = queryObj;
      const params = {
        dictCode: "payChnl",
        dictName: "支付渠道",
        dictDesc,
        dictDetailCode,
        dictValue: {
          payFor,
          callbackSuffix
        }
      };
      if ((_props$editItem2 = props.editItem) !== null && _props$editItem2 !== void 0 && _props$editItem2.id) {
        var _props$editItem3;
        params.id = (_props$editItem3 = props.editItem) === null || _props$editItem3 === void 0 ? void 0 : _props$editItem3.id;
      }
      try {
        var _props$editItem4;
        const {
          code,
          msg
        } = (_props$editItem4 = props.editItem) !== null && _props$editItem4 !== void 0 && _props$editItem4.id ? await editPayChnl(params) : await addPayChnl(params);
        if (code === '0') {
          message.success(msg);
          emit('update:modalVisible', false);
          emit('refresh');
        }
      } catch (e) {}
    };
    const closeModal = () => {
      var _accountForm$value;
      (_accountForm$value = accountForm.value) === null || _accountForm$value === void 0 || _accountForm$value.clearValidate();
      emit('clearEditItem', {});
      emit('update:modalVisible', false);
    };
    const handleOk = () => {
      var _accountForm$value2;
      (_accountForm$value2 = accountForm.value) === null || _accountForm$value2 === void 0 || _accountForm$value2.validate().then(() => {
        changeform(formValue.value);
      }).catch(error => {});
    };
    // 控制弹窗展示
    watch(() => props.modalVisible, val => {
      visible.value = val;
      if (props.editItem) {
        var _props$editItem$dictV, _props$editItem$dictV2;
        //编辑
        formValue.value = {
          dictDesc: props.editItem.dictDesc,
          dictDetailCode: props.editItem.dictDetailCode,
          payFor: (_props$editItem$dictV = props.editItem.dictValue) === null || _props$editItem$dictV === void 0 ? void 0 : _props$editItem$dictV.payFor,
          callbackSuffix: (_props$editItem$dictV2 = props.editItem.dictValue) === null || _props$editItem$dictV2 === void 0 ? void 0 : _props$editItem$dictV2.callbackSuffix
        };
      } else {
        // 新增
        formValue.value = {
          dictDesc: '',
          dictDetailCode: '',
          payFor: undefined,
          callbackSuffix: ''
        };
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: visible.value,
        "onUpdate:open": _cache[4] || (_cache[4] = $event => visible.value = $event),
        title: _unref(isEdit) ? '编辑' : '新增',
        width: "444px",
        "ok-text": "提交",
        onOk: handleOk,
        onCancel: closeModal,
        centered: "",
        maskClosable: false
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, {
          name: "accountForm",
          model: formValue.value,
          ref_key: "accountForm",
          ref: accountForm
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "支付渠道",
            name: "dictDesc",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: formValue.value.dictDesc,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => formValue.value.dictDesc = $event),
              valueModifiers: {
                trim: true
              },
              autoComplete: "off",
              allowClear: "",
              placeholder: "请输入支付渠道"
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "Paychnl",
            name: "dictDetailCode",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: formValue.value.dictDetailCode,
              "onUpdate:value": _cache[1] || (_cache[1] = $event => formValue.value.dictDetailCode = $event),
              valueModifiers: {
                trim: true
              },
              allowClear: "",
              placeholder: "请输入Paychnl",
              disabled: _unref(isEdit),
              autoComplete: "off"
            }, null, 8, ["value", "disabled"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "类型",
            name: "payFor",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              value: formValue.value.payFor,
              "onUpdate:value": _cache[2] || (_cache[2] = $event => formValue.value.payFor = $event),
              placeholder: "请选择类型",
              options: typeList.value
            }, null, 8, ["value", "options"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "回调地址后缀",
            name: "callbackSuffix"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              autoComplete: "off",
              value: formValue.value.callbackSuffix,
              "onUpdate:value": _cache[3] || (_cache[3] = $event => formValue.value.callbackSuffix = $event),
              valueModifiers: {
                trim: true
              },
              placeholder: "请输入回调地址后缀"
            }, null, 8, ["value"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["open", "title"]);
    };
  }
});